import TermsAndConditionsBlock from 'components/Info/TermsAndConditionsBlock';

const TermsAndConditionsPage = () => {
  return <TermsAndConditionsBlock />;
};

export default TermsAndConditionsPage;
